import React from "react";

/**
 * Single removable filter chip: a bold headline with an optional muted subtext line.
 * Shared visual building block for the active-filter bar and per-source meeting chips,
 * so every filter pill in the toolbar looks and behaves the same.
 *
 * @example
 * <ActionItemsFilterChip main="Gmail" sub="sam@co.com" onRemove={() => {}} ariaLabel="Remove Gmail filter" />
 */
const ActionItemsFilterChip = ({ main, sub = "", onRemove, ariaLabel, className = "" }) => (
  <div
    className={["action-items-active-filter", className].filter(Boolean).join(" ")}
    role="status"
    aria-live="polite"
  >
    <button
      type="button"
      className="action-items-active-filter__clear"
      onClick={onRemove}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      ×
    </button>
    <span className="action-items-active-filter__text">
      <span className="action-items-active-filter__label">{main}</span>
      {sub ? <span className="action-items-active-filter__sub">{sub}</span> : null}
    </span>
  </div>
);

export default ActionItemsFilterChip;
